import { render, staticRenderFns } from "./categoryRegionSelect.vue?vue&type=template&id=80b3969e&scoped=true"
import script from "./categoryRegionSelect.vue?vue&type=script&lang=js"
export * from "./categoryRegionSelect.vue?vue&type=script&lang=js"
import style0 from "./categoryRegionSelect.vue?vue&type=style&index=0&id=80b3969e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b3969e",
  null
  
)

export default component.exports